import React from 'react';
import { Outlet, useMatch } from 'react-router-dom';
import { paths } from '@/app/paths';
import { AuthenticatedPageLayout } from '@/components/layouts/AuthenticatedPageLayout';
import { AdminModeProvider } from '@/context/adminModeContext';

/**
 * Element for the root route. Renders the page layout once for every page under it, so
 * navigating between pages doesn't remount the nav, drawers and auth hooks.
 */
export const AppLayout = () => {
	// Admin mode is the route: every page under /admin is in admin mode.
	const isAdminRoute = Boolean(useMatch(`${paths.admin}/*`));

	return (
		<AdminModeProvider isAdminMode={isAdminRoute}>
			<AuthenticatedPageLayout>
				<Outlet />
			</AuthenticatedPageLayout>
		</AdminModeProvider>
	);
};
